import { useEffect } from 'react';
import { scrollToHashTarget, scrollToHashWhenReady } from '@/lib/hashScroll';

/**
 * Corrige scroll a #anclas en SPA: al abrir /#contacto el navegador suele quedarse en el hero.
 */
export function useHashScrollOnLoad(): void {
  useEffect(() => {
    if (!window.location.hash) return;
    scrollToHashWhenReady();
  }, []);

  useEffect(() => {
    const onHashChange = () => {
      if (window.location.hash) scrollToHashTarget();
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
}
